import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { MediaServerLazyImage } from '@/scopes/common/components/MediaServerLazyImage'
import SectionTitle from '@/scopes/destinations/components/SectionTitle'
import { useRegionsTitleKey } from '@/scopes/destinations/components/useRegionsTitleKey'
import { RegionCard } from '@sunwebgroup/uds-ui/region-card'
import styles from './OtherRegions.module.css'

export default function OtherRegions() {
  const intl = useIntl()

  const regions = useCMSPageField('DestinationPage.otherRegions')

  const title = useRegionsTitleKey('other_regions')

  if (regions.length === 0) {
    return null
  }

  return (
    <section>
      <SectionTitle>{intl.formatMessage({ id: title })}</SectionTitle>
      <div className={styles.regionsGrid}>
        {regions.map(region => (
          <a href={region.link} key={region.name} className={styles.regionLink}>
            <RegionCard
              text={region.name}
              src={region.image}
              aspectRatio="16:9"
              alt={intl.formatMessage({ id: 'destination_region_img_alt' }, { regionName: region.name })}
              imageSlot={props => (
                <MediaServerLazyImage
                  {...props}
                  widths={[320, 480, 600]}
                />
              )}
            />
          </a>
        ))}
      </div>
    </section>
  )
}
